var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42284 8.20331C7.2933 8.2747 7.1478 8.31214 6.99989 8.31214C6.85198 8.31214 6.70648 8.2747 6.57694 8.20331L0.4375 4.81641V11.1564C0.437847 11.5044 0.57624 11.8381 0.822306 12.0841C1.06837 12.3302 1.40201 12.4686 1.75 12.4689H12.25C12.598 12.4686 12.9316 12.3302 13.1777 12.0841C13.4238 11.8381 13.5622 11.5044 13.5625 11.1564V4.81641L7.42284 8.20331Z",
    fill: "#909599"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 1.53125H1.75C1.40201 1.5316 1.06837 1.66999 0.822306 1.91606C0.57624 2.16212 0.437847 2.49576 0.4375 2.84375V3.9375C0.437485 3.97664 0.44797 4.01506 0.467862 4.04877C0.487754 4.08247 0.516325 4.11022 0.550594 4.12912L6.89434 7.62912C6.9267 7.64697 6.96305 7.65633 7 7.65633C7.03695 7.65633 7.0733 7.64697 7.10566 7.62912L13.4494 4.12912C13.4837 4.11022 13.5122 4.08247 13.5321 4.04877C13.552 4.01506 13.5625 3.97664 13.5625 3.9375V2.84375C13.5622 2.49576 13.4238 2.16212 13.1777 1.91606C12.9316 1.66999 12.598 1.5316 12.25 1.53125Z",
    fill: "#909599"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8fe9f0a9.svg";
export { ForwardRef as ReactComponent };